import { ApiDimension, ApiMetric, ApiTableGrouping } from "@incendium/api";
import { Box } from "@mui/material";
import { TTableCustomCellRender } from "features/analytics";
import useDimensionQueryParams from "features/analytics/hooks/useDimensionQueryParams";
import {
  ExplorerSidebar,
  ExplorerTable,
  useExplorerContext,
} from "features/explorer";
import { ExplorerSidebarSection } from "features/explorer/types";
// import { TOP_BAR_HEIGHT } from "features/leftMenu/constants";
import { useEffect, useState } from "react";
import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import ExplorerTopBar from "./ExplorerTopBar";

interface IContentExplorerProps {
  metrics: ApiMetric[];
  limit?: number;
  dimensionNoClick?: boolean;
  colWidths?: { [key: string]: number };
  dontIncludeEmpty?: boolean;
  tableCustomHeaderRender?: TTableCustomCellRender;
  ignoreAttrModel?: boolean;
  groupedMetrics?: ApiTableGrouping[];
}

function ContentExplorer({
  metrics,
  limit,
  dimensionNoClick,
  colWidths,
  dontIncludeEmpty,
  tableCustomHeaderRender,
  ignoreAttrModel,
  groupedMetrics,
}: IContentExplorerProps) {
  const { dimension, setAttributes, setDimension } = useExplorerContext();
  const [open, setOpen] = useState(false);
  const [focusedSection, setFocusedSection] = useState<
    ExplorerSidebarSection | undefined
  >();
  const history = useHistory();
  const dimensionQueryParams = useDimensionQueryParams();

  const openSidebar = useCallback((section?: ExplorerSidebarSection) => {
    setFocusedSection(section);
    setOpen(true);
  }, []);

  const closeSidebar = useCallback(() => {
    setOpen(false);
    setFocusedSection(undefined);
  }, []);

  const onClick = useCallback(
    (s, o) => {
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.set(
        [
          ApiDimension.DIMENSION_CONVERTING_SESSION_JOURNEY,
          ApiDimension.DIMENSION_SALES_SESSION_JOURNEY,
        ].includes(dimension)
          ? ApiDimension.DIMENSION_LOCATION
          : dimension,
        typeof s === "string" ? s : s[dimension],
      );
      const updatedSearchString = searchParams.toString();
      history.push({
        pathname: "./content-performance-analysis",
        search: updatedSearchString,
      });
    },
    [dimension, history],
  );

  useEffect(() => {
    Object.entries(dimensionQueryParams).forEach(([k, v]) => {
      setAttributes([
        {
          key: k,
          value: v || "",
        },
      ]);
      setDimension(ApiDimension.DIMENSION_BROWSER);
      return;
    });
  }, [dimensionQueryParams, setAttributes, setDimension]);

  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        flexWrap: "nowrap",
        gap: 2,
      }}
    >
      <ExplorerTopBar onOpenSidebar={openSidebar} />

      <Box sx={{ minHeight: 0, flexGrow: 1 }} pb={2}>
        <ExplorerTable
          groupedMetrics={groupedMetrics}
          dontIncludeEmpty={dontIncludeEmpty}
          tableCustomHeaderRender={tableCustomHeaderRender}
          onClick={
            Object.keys(dimensionQueryParams).length === 0 && !dimensionNoClick
              ? { [dimension]: onClick }
              : undefined
          }
          metrics={metrics}
          limit={limit}
          colWidths={colWidths}
          ignoreAttrModel={ignoreAttrModel}
        />
      </Box>
      <ExplorerSidebar
        open={open}
        onClose={closeSidebar}
        focusedSection={focusedSection}
      />
    </Box>
  );
}

export default ContentExplorer;
